// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"jca-z","narrowOptionButtons":"kca-z","noOptions":"lca-z"};